import * as actionTypes from "../actions/actionTypes";

const intialState = {
  isLoading: false,
  error: "",
  checkMerchantKyc: "",
  aepsMerchantKyc: "",
  aepsToDmt: "",
  getAepsBankDetails: "",
  pennyDrop: "",
  addBank: "",
  aepsPayoutToBank: "",
};

// get check Balance
const checkMerchantKycStart = (state) => {
  return {
    ...state,
    isLoading: true,
    checkMerchantKyc: "",
    error: "",
  };
};

const checkMerchantKycSuccess = (state, data) => {
  return {
    ...state,
    checkMerchantKyc: data,
    isLoading: false,
    error: "",
  };
};

const checkMerchantKycFail = (state, err) => {
  return {
    ...state,
    error: err,
    isLoading: false,
  };
};

// aeps merchant kyc
const aepsMerchantKycStart = (state) => {
  return {
    ...state,
    isLoading: true,
    aepsMerchantKyc: "",
  };
};

const aepsMerchantKycSuccess = (state, data) => {
  return {
    ...state,
    aepsMerchantKyc: data,
    isLoading: false,
  };
};

const aepsMerchantKycFail = (state, err) => {
  return {
    ...state,
    error: err,
    isLoading: false,
  };
};

// aeps transact kyc

const aepsTransactStart = (state) => {
  return {
    ...state,
    isLoading: true,
    aepsTransact: "",
  };
};

const aepsTransactSuccess = (state, data) => {
  return {
    ...state,
    aepsTransact: data,
    isLoading: false,
    error: "",
  };
};

const aepsTransactFail = (state, err) => {
  return {
    ...state,
    error: err,
    isLoading: false,
  };
};

// aeps transact kyc

const aepsToDmtStart = (state) => {
  return {
    ...state,
    isLoading: true,
    aepsToDmt: "",
  };
};

const aepsToDmtSuccess = (state, data) => {
  return {
    ...state,
    aepsToDmt: data,
    isLoading: false,
    error: "",
  };
};

const aepsToDmtFail = (state, err) => {
  return {
    ...state,
    error: err,
    isLoading: false,
  };
};

// get aeps bank details

const getAepsBankDetailsStart = (state) => {
  return {
    ...state,
    isLoading: true,
    getAepsBankDetails: "",
  };
};

const getAepsBankDetailsSuccess = (state, data) => {
  return {
    ...state,
    getAepsBankDetails: data,
    isLoading: false,
    error: "",
  };
};

const getAepsBankDetailsFail = (state, err) => {
  return {
    ...state,
    error: err,
    isLoading: false,
  };
};

//penny drop

const pennyDropStart = (state) => {
  return {
    ...state,
    isLoading: true,
    pennyDrop: "",
  };
};

const pennyDropSuccess = (state, data) => {
  return {
    ...state,
    pennyDrop: data,
    isLoading: false,
    error: "",
  };
};

const pennyDropFail = (state, err) => {
  return {
    ...state,
    error: err,
    isLoading: false,
  };
};

//aeps add bank

const addBankStart = (state) => {
  return {
    ...state,
    isLoading: true,
    addBank: "",
  };
};

const addBankSuccess = (state, data) => {
  return {
    ...state,
    addBank: data,
    isLoading: false,
    error: "",
  };
};

const addBankFail = (state, err) => {
  return {
    ...state,
    error: err,
    isLoading: false,
  };
};

//aeps to bank

const aepsPayoutToBankStart = (state) => {
  return {
    ...state,
    isLoading: true,
    aepsPayoutToBank: "",
  };
};

const aepsPayoutToBankSuccess = (state, data) => {
  return {
    ...state,
    aepsPayoutToBank: data,
    isLoading: false,
    error: "",
  };
};

const aepsPayoutToBankFail = (state, err) => {
  return {
    ...state,
    error: err,
    isLoading: false,
  };
};

//reset Aeps func

const resetAepsFunc = (state) => {
  return {
    ...state,

    aepsMerchantKyc: "",
    aepsToDmt: "",
    pennyDrop: "",
    aepsPayoutToBank: "",
  };
};

const AepsReducer = (state = intialState, action) => {
  switch (action.type) {
    case actionTypes.CHECK_MERCHANT_KYC_START:
      return checkMerchantKycStart(state);
    case actionTypes.CHECK_MERCHANT_KYC_SUCCESS:
      return checkMerchantKycSuccess(state, action.data);
    case actionTypes.CHECK_MERCHANT_KYC_FAIL:
      return checkMerchantKycFail(state, action.err);

    case actionTypes.AEPS_MERCHANT_KYC_START:
      return aepsMerchantKycStart(state);
    case actionTypes.AEPS_MERCHANT_KYC_SUCCESS:
      return aepsMerchantKycSuccess(state, action.data);
    case actionTypes.AEPS_MERCHANT_KYC_FAIL:
      return aepsMerchantKycFail(state, action.err);

    case actionTypes.AEPS_TRANSACT_START:
      return aepsTransactStart(state);
    case actionTypes.AEPS_TRANSACT_SUCCESS:
      return aepsTransactSuccess(state, action.data);
    case actionTypes.AEPS_TRANSACT_FAIL:
      return aepsTransactFail(state, action.err);

    case actionTypes.AEPS_TO_DMT_START:
      return aepsToDmtStart(state);
    case actionTypes.AEPS_TO_DMT_SUCCESS:
      return aepsToDmtSuccess(state, action.data);
    case actionTypes.AEPS_TO_DMT_FAIL:
      return aepsToDmtFail(state, action.err);

    case actionTypes.GET_AEPS_BANK_LIST_START:
      return getAepsBankDetailsStart(state);
    case actionTypes.GET_AEPS_BANK_LIST_SUCCESS:
      return getAepsBankDetailsSuccess(state, action.data);
    case actionTypes.GET_AEPS_BANK_LIST_FAIL:
      return getAepsBankDetailsFail(state, action.err);

    case actionTypes.AEPS_PENNY_DROP_START:
      return pennyDropStart(state);
    case actionTypes.AEPS_PENNY_DROP_SUCCESS:
      return pennyDropSuccess(state, action.data);
    case actionTypes.AEPS_PENNY_DROP_FAIL:
      return pennyDropFail(state, action.err);

    case actionTypes.ADD_BANK_START:
      return addBankStart(state);
    case actionTypes.ADD_BANK_SUCCESS:
      return addBankSuccess(state, action.data);
    case actionTypes.ADD_BANK_FAIL:
      return addBankFail(state, action.err);

    case actionTypes.AEPS_PAYOUT_TO_BANK_START:
      return aepsPayoutToBankStart(state);
    case actionTypes.AEPS_PAYOUT_TO_BANK_SUCCESS:
      return aepsPayoutToBankSuccess(state, action.data);
    case actionTypes.AEPS_PAYOUT_TO_BANK_FAIL:
      return aepsPayoutToBankFail(state, action.err);

    case actionTypes.AEPS_MERCHANT_KYC_RESET:
      return resetAepsFunc(state);

    default:
      return state;
  }
};

export default AepsReducer;
